import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { MAILTO } from '../../utils/mailto';
export function CoffeeCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  return <section ref={ref} className="w-full py-20 sm:py-28 bg-white" data-id="element-11">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <motion.div className="relative overflow-hidden rounded-3xl px-8 py-16 sm:px-16 sm:py-20 text-center" style={{
        background: 'linear-gradient(135deg, #2D6A4F 0%, #1B4332 100%)'
      }} initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-13">
          {/* Decorative elements */}
          <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full opacity-10" style={{
          background: 'radial-gradient(circle, #52B788, transparent)'
        }} aria-hidden="true" data-id="element-14" />
          <div className="absolute -bottom-16 -left-16 w-48 h-48 rounded-full opacity-10" style={{
          background: 'radial-gradient(circle, #6BCB77, transparent)'
        }} aria-hidden="true" data-id="element-15" />

          {/* Coffee bean decorations */}
          <div className="absolute top-8 right-12 text-4xl opacity-20 select-none" aria-hidden="true" data-id="element-16">
            ☕
          </div>
          <div className="absolute bottom-10 left-10 text-3xl opacity-15 select-none" aria-hidden="true" data-id="element-17">
            🌱
          </div>

          <h2 className="relative text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight leading-tight max-w-3xl mx-auto" data-id="element-18">
            Every cup tells a story.
            <br data-id="element-19" />
            <span className="text-carbon-bright" data-id="element-20">Make yours transparent.</span>
          </h2>
          <p className="relative mt-5 text-lg text-white/70 max-w-xl mx-auto" data-id="element-21">
            Join the growing movement of coffee brands using CarbonSafe to prove
            their sustainability claims with verifiable, farm-to-cup data.
          </p>
          <div className="relative mt-10 flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-22">
            <a href={MAILTO.coffeeDemo} className="inline-flex items-center gap-2 px-8 py-4 bg-carbon-bright text-white text-base font-semibold rounded-lg hover:bg-carbon-light transition-colors shadow-lg shadow-black/20" data-id="element-23">
              Start Tracing Your Coffee
              <ArrowRightIcon className="w-4 h-4" data-id="element-24" />
            </a>
            <a href={MAILTO.coffeeCaseStudy} className="inline-flex items-center gap-2 px-8 py-4 border-2 border-white/30 text-white text-base font-semibold rounded-lg hover:bg-white/10 transition-colors" data-id="element-25">
              Download Case Study
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}